import { Link } from 'react-router-dom';
import NoticeBody from '../components/NoticeBody';
import { useTerms } from '../hooks/useTerms';
import { readerLocale } from '../i18n/language';
import { colors } from '../styles/theme';

/**
 * The Terms and Conditions in force, public (0181). While the text is a placeholder a DRAFT banner says
 * so; counsel's text is a new version shipped with a migration, in English and Spanish, with no
 * change to this page.
 */
export default function Terms(): JSX.Element {
  const { terms, unavailable } = useTerms();

  return (
    <div className="min-h-screen p-6" style={{ background: colors.canvas }}>
      <main
        className="mx-auto max-w-2xl rounded-2xl p-8"
        style={{ background: colors.surface, border: `1px solid ${colors.border}` }}
      >
        <h1 className="text-2xl font-bold mb-3" style={{ color: colors.ink }}>
          Terms and Conditions
        </h1>
        <NoticeBody document="terms" notice={terms} unavailable={unavailable} />
        {terms && (
          <p className="mt-4 text-xs" style={{ color: colors.muted }}>
            {`Version ${terms.version} · in effect since ${new Date(terms.published_at).toLocaleDateString(readerLocale())}`}
          </p>
        )}
        <p className="mt-6 text-sm">
          <Link to="/login" className="underline" style={{ color: colors.navy }}>
            Back to sign in
          </Link>
        </p>
      </main>
    </div>
  );
}
